import { route } from "quasar/wrappers";
import { supabase } from "src/boot/supabase";
import { Notify } from "quasar";
import { useSettingsStore } from "src/stores/settings";
import { Quasar } from "quasar";
import i18n from "../i18n";

const locale = Quasar.lang.getLocale() === "nl-NL" ? "nl-NL" : "en-US";

import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import routes from "./routes";
import { trackSitePageView } from "src/modules/siteAnalytics/services/sitePageViewService";
import { pageForRoute } from "src/modules/siteAnalytics/domain/pageTracking";
import {
  syncBrowserThemeColor,
  themeColorForRoute,
} from "src/services/browserThemeColor";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: (to) =>
      to.hash ? { el: to.hash, top: 76 } : { left: 0, top: 0 },
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === "ssr" ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  Router.beforeEach(async (to, from) => {
    if (process.env.WHEEL_NATIVE) {
      if (to.path === "/") return { path: "/app-preview", replace: true };
      return true;
    }

    const store = useSettingsStore();
    const { data, error } = await supabase.auth.getSession();
    const session = data?.session || null;
    if (error) console.warn("Could not restore the auth session", error);
    store.setSession(session);

    if (!session && to.meta.requiresAuth) {
      Notify.create({
        message: i18n[locale].app.messages.NO_PAGE_ACCES,
        color: "accent",
        actions: [
          {
            label: i18n[locale].app.buttons.LOGIN,
            color: "white",
            handler: () => {},
          },
        ],
      });
      // setTimeout to allow notification to show

      // redirect to account page
      return {
        path: "/account",
        query: {
          redirect: to.fullPath,
          ...(to.path === "/kompas" ? { signup: "true" } : {}),
        },
      };
    }
  });

  Router.afterEach((to, _from, failure) => {
    syncBrowserThemeColor(themeColorForRoute(to.path));
    if (process.env.WHEEL_NATIVE) return;
    const pageKey = pageForRoute(to)?.key;
    if (failure || !pageKey || to.query.test === "true") return;

    trackSitePageView(pageKey).catch((error) => {
      console.warn("Site page view could not be tracked", error);
    });
  });

  return Router;
});
